var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.booking.is_offer
    ? _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", [
          _vm._v("\n    " + _vm._s(_vm.$starLabel) + " Recommendations\n  "),
        ]),
        _vm._v(" "),
        _vm.haveNoRecommendedTalent
          ? _c("div", { staticClass: "text-center alert alert-default" }, [
              _vm._v(
                "\n    There are no recommended " +
                  _vm._s(_vm.$starLabelPlural) +
                  ".\n  "
              ),
            ])
          : _c(
              "ul",
              { staticClass: "tags" },
              _vm._l(_vm.recommendations, function (talent) {
                return _c("li", { key: "current" + talent.id }, [
                  _vm.isRecommended(talent)
                    ? _c("span", { staticStyle: { color: "#44bd6c" } }, [
                        _vm._v(_vm._s(talent.name)),
                      ])
                    : _c("span", [_vm._v(_vm._s(talent.name))]),
                ])
              }),
              0
            ),
        _vm._v(" "),
        _c("div", { staticClass: "form-item__row" }, [
          _c("div", { staticClass: "form-item__field" }, [
            !_vm.$vlastMode
              ? _c(
                  "div",
                  { staticClass: "input-group input-group-booking-detail" },
                  [
                    _c("span", { staticClass: "input-group-addon" }, [
                      _vm._v("Compare With Version:"),
                    ]),
                    _vm._v(" "),
                    _c("selectize", {
                      staticClass: "selectize selectize-single",
                      attrs: {
                        name: "engine_version",
                        "disable-delete": true,
                        options: _vm.versions,
                      },
                      model: {
                        value: _vm.version,
                        callback: function ($$v) {
                          _vm.version = $$v
                        },
                        expression: "version",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _vm.versionTalent
          ? _c(
              "ul",
              { staticClass: "tags" },
              _vm._l(_vm.versionTalent, function (talent) {
                return _c("li", { key: "version" + talent.id }, [
                  _vm.isRecommended(talent)
                    ? _c("span", { staticStyle: { color: "#44bd6c" } }, [
                        _vm._v(_vm._s(talent.name + " " + talent.score)),
                      ])
                    : _c("span", [
                        _vm._v(_vm._s(talent.name + " " + talent.score)),
                      ]),
                ])
              }),
              0
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }